import { IBlocks, IUserData } from "@/types";

const BlockClickHandler = (
    account: IUserData,
    button: React.MouseEvent,
    block: IBlocks,
    edit?: boolean
) => {
    if ((button.button == 0 && !edit) || (button.button == 1 && !edit)) {
        fetch("/api/user/click", {
            method: "POST",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify({
                account_id: account.id,
                block_id: block.id,
            }),
        });
    }
};
export default BlockClickHandler;
